var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav",style:({ width: _vm.navList.length * 400 + 'px' })},_vm._l((_vm.navList),function(nav){return _c('router-link',{key:nav.name,staticClass:"menu_item",attrs:{"tag":"div","to":nav.path,"active-class":"menu_item_ac"}},[_c('div',{staticClass:"txt"},[_vm._v(_vm._s(nav.meta.showName))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }